import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import BlogScreen from "./BlogScreen";
import axiosInstance from "../../../config/axiosInstance"; 
import SEO from '../Seo'

const BlogScreenWrapper = () => {
  const { id } = useParams(); 
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
console.log(id, "id")
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axiosInstance.get(`/api/blogs/slug/${id}`);
        setBlog(response.data);
      } catch (err) {
        setError(err.response?.status === 404 ? "not-found" : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error === "not-found") {
    return <Navigate to="/blogs" replace />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return ( 
  <>
  <SEO
      pageTitle={blog.metaTitle || blog.title}
      canonicalUrl={blog.canonicalUrl || `https://rrumidiamond.co//${blog.slug}`}
      metaDescription={blog.metaDescription}
      metaKeywords={blog.metaKeywords}
      ogTitle={blog.ogTitle || blog.metaTitle}
      ogDescription={blog.ogDescription || blog.metaDescription}
      ogImage={blog.bannerImage[0]}
      ogUrl={blog.ogUrl || `https://rrumidiamond.co//${blog.slug}`}
    />
  <BlogScreen blog={blog}  setBlog = {setBlog} loading = {loading} setLoading = {setLoading}/>;
  </>
  )
};

export default BlogScreenWrapper;
